import { GrowthBook } from '@growthbook/growthbook';

export default defineNuxtPlugin(async (nuxtApp) => {
  const { hostUrl, growthbookApiHost, growthbookSdkKey } =
    useRuntimeConfig().public;

  const options = {
    enableDevMode: process.env.NODE_ENV !== 'production',
    apiHost: growthbookApiHost,
    clientKey: growthbookSdkKey,
    trackingCallback: (experiment, result) => {
      const event = {
        name: 'Experiment Started',
        data: {
          'Experiment Id': experiment.key,
          'Variant Id': result.variationId,
          $source: 'growthbook',
        },
      };

      if (!import.meta.env.SSR) {
        nuxtApp.$analytics.track(event.name, event.data, {
          plugins: {
            all: false,
            mixpanel: true,
            googleAnalytics: true,
          },
        });
      }
    },
  };

  const growthbook = new GrowthBook(options);

  growthbook.loading = true;

  const growthbookUrl = growthbookApiHost.replace(/\/+$/, '');
  const { features, experiments } = await $fetch(
    `${growthbookUrl}/api/features/${growthbookSdkKey}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  );

  growthbook.setFeatures(features);
  growthbook.setExperiments(experiments);
  const route = useRoute();

  const uniqueIdCookie = useCookie('exp_uniqueId');
  let uniqueId = uniqueIdCookie.value;
  if (!uniqueId) {
    uniqueId = crypto.randomUUID();
    uniqueIdCookie.value = uniqueId;
  }

  const dataDogCookie = useCookie('datadog-synthetics-public-id');

  await growthbook.setAttributes({
    id: uniqueId,
    url: `${hostUrl}${route.fullPath}`,
    slug: route.fullPath,
    proxifier: !!route.query?.proxifier,
    datadog_test_id: dataDogCookie.value,
  });

  growthbook.loading = false;
  nuxtApp.provide('growthbook', growthbook);
});
